import Loading from '../../components/Loading';
import Component from '../../components/Component';

import { query_get_average } from './query';
import LowCTR from './content';
import numeral from 'numeral';
import { withTranslation } from 'react-i18next';

class LowCTRContainer extends Component {
    constructor() {
        super();
        this.query = query_get_average;
    }

    showMore() {
        this.setState({
            isShowMore: true,
        });
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Loading />;
        }

        const extraBox = () => (
            <div className="table-header-subtitle mb-10">
                <div>
                    <div className="mb-10">
                        {t('opportunities.discover.ctr.text1', {
                            avgctr: numeral(this.state.data[0]?.avgctr).format('0.0%'),
                        })}
                    </div>
                    <div>
                        {' '}
                        <i className="icon-lightbulb-solid lightbulb-styles"></i>
                        {t('opportunities.discover.ctr.text2')}
                    </div>
                </div>
            </div>
        );

        return (
            <div className="card table-main rounded-main overflow-hidden">
                <LowCTR
                    domain={this.props.domain}
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    avgctr={this.state.data[0]?.avgctr ?? 0}
                    default_image={this.props.default_image}
                    extraBtns={extraBox}
                    t={t}
                />
            </div>
        );
    }
}

export default withTranslation()(LowCTRContainer);
